import { IllegalArgumentError, IllegalStateError, } from '../../sdk/errors';
export class MessagingFacade {
    constructor(delegates) {
        this.delegates = delegates;
        this.type = 'messaging-facade';
        if (delegates.length < 1) {
            throw new IllegalArgumentError('Expected to have at least on messaging backend.');
        }
    }
    create(command) {
        const messaging = this.getPreferableMessaging(command.type);
        return messaging.create(command);
    }
    async find(query) {
        if ('id' in query && query.id.type) {
            const messaging = this.lookUpMessagingBackend(query.id.type);
            return messaging.find(query);
        }
        for (const messaging of this.delegates) {
            try {
                const thread = await messaging.find(query);
                if (thread) {
                    return thread;
                }
            }
            catch (e) {
                console.error(e);
            }
        }
        return null;
    }
    async findAll() {
        const allSettled = await Promise.allSettled(this.delegates.map((messaging) => messaging.findAll()));
        const errors = allSettled
            .filter((it) => it.status === 'rejected')
            .map((it) => it)
            .map((it) => it.reason);
        if (errors.length > 0) {
            console.error(`Error during finding dialects: ${errors.map((it) => JSON.stringify(it))}`);
        }
        const fulfilled = allSettled.filter((it) => it.status === 'fulfilled');
        if (errors.length > 0 && fulfilled.length === 0) {
            const error = {
                ...errors[0],
                details: errors,
            };
            throw error;
        }
        return fulfilled
            .map((it) => it)
            .map((it) => it.value)
            .flat()
            .sort((t1, t2) => t2.updatedAt.getTime() - t1.updatedAt.getTime());
    }
    async findSummary(query) {
        for (const messaging of this.delegates) {
            try {
                const thread = await messaging.findSummary(query);
                if (thread) {
                    return thread;
                }
            }
            catch (e) {
                console.error(e);
            }
        }
        return null;
    }
    async findSummaryAll() {
        for (const messaging of this.delegates) {
            try {
                const summary = await messaging.findSummaryAll();
                if (summary) {
                    return summary;
                }
            }
            catch (e) {
                console.error(e);
            }
        }
        return null;
    }
    getPreferableMessaging(type) {
        if (type) {
            return this.lookUpMessagingBackend(type);
        }
        return this.getFirstAccordingToPriority();
    }
    lookUpMessagingBackend(type) {
        const messagingBackend = this.delegates.find(({ type: t }) => type === t);
        if (!messagingBackend) {
            throw new IllegalArgumentError(`Backend ${type} is not configured in sdk.`);
        }
        return messagingBackend;
    }
    getFirstAccordingToPriority() {
        const messaging = this.delegates[0];
        if (!messaging) {
            throw new IllegalStateError('Should not happen.');
        }
        return messaging;
    }
}
//# sourceMappingURL=messaging-facade.js.map